import styled from 'styled-components';
import Box from '../../../../_shared/components/Box';

export const StyledBox = styled(Box.Column)`
  margin-left: 18px;
  grid-row-gap: 5px;
  width: 100%;
`;

export const StyledFooter = styled.div`
  width: 100%;
  height: 36px;
  margin-top: 50px;
  border-top: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
`;

export const StyledThumbnail = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  margin: 12px;
`;
